import React, { useContext, useEffect, useRef } from "react";
import "../css/paysuccess.css";
import { FiCheck, FiX } from "react-icons/fi";
import { Link, useSearchParams } from "react-router-dom";
import { CartContext } from "./CartContext";

const PaySuccess = () => {
  const [params] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const success = params.get("state") === "success";
  const cleared = useRef(false);
  useEffect(() => {
    if (success && !cleared.current) {
      cleared.current = true;
      clearCart();
    }
  }, [success, clearCart]);
  return <main className={`successDiv ${success ? "is-success" : "is-cancel"}`}><div className="success-container"><div className="checkmark-circle">{success ? <FiCheck /> : <FiX />}</div><p>{success ? "ORDER CONFIRMED" : "PAYMENT NOT COMPLETED"}</p><h1>{success ? "Thank you for your order." : "Your order is still waiting."}</h1><span>{success ? "Payment was successful. A confirmation will be sent to your email." : "No payment was completed and your bag has been kept. You can return to checkout when you are ready."}</span><Link to={success ? "/shop" : "/checkout"}>{success ? "KEEP BROWSING" : "RETURN TO CHECKOUT"}</Link></div></main>;
};

export default PaySuccess;
